// extracted by mini-css-extract-plugin
export default {"innerWrapper":"pu-z","tooltipWrapper":"qu-z","icon":"ru-z","tooltip":"su-z","content":"tu-z"};